import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AssessmentContextLayout } from './hooks/AssessmentProvider';

import './dayjs';

import Report from './wg/report/WGAssessmentReport';
import TeamMapReport from './wg/report/TeamMapTemplate';
import PodcastPdf from './wg/podcast/PodcastPdf';
import TTGPodcastPdf from './ttg/Podcast/PodcastPdf';
import TTGArticlePdf from './ttg/Article/ArticlePdf';
import SummaryReportPdf from './wg/staffing-matcher/SummaryReportPdf';
import ITPAssessmentReport from "./itp/ITPAssessmentReport";
import ITPProgressReport from "./itp/ITPProgressReport";
import OrderPrintReceipt from "./ttg/Order/OrderPrintReceipt";

import './styles/wg/fontello/animation.css';
import './styles/wg/fontello/fontello.css';
import './styles/wg/fontello/fontello-codes.css';
import './styles/wg/fontello/fontello-embedded.css';
import './styles/wg/fontello/fontello-ie7.css';
import './styles/wg/fontello/fontello-ie7-codes.css';
import './styles/wg/index.scss';
import {TTGAssessmentContextLayout} from "./hooks/TTGAssessementProvider";
import TTGReport from "./ttg/Assessment/ReportPage";
import ProgressReport from "./ttg/Assessment/ProgressReportPage";
import SurveyPdf from "./ttg/Ohs/SurveyPdf";

const root = ReactDOM.createRoot(document.getElementById('root'));

const router = createBrowserRouter([
    { path: '/pdf/assessment/assessmentReport', element: <Report /> },
    { path: '/pdf/teamMap/teamMapReport', element: <AssessmentContextLayout><TeamMapReport /></AssessmentContextLayout> },
    { path: '/pdf/podcast/podcastPdf', element: <PodcastPdf /> },
    { path: '/pdf/podcast/ttgPodcastPdf', element: <TTGPodcastPdf /> },
    { path: '/pdf/report/summary', element: <SummaryReportPdf /> },
    { path: '/pdf/itp/ASSESSMENT', element: <ITPAssessmentReport /> },
    { path: '/pdf/itp/PROGRESS', element: <ITPProgressReport /> },
    { path: '/pdf/order', element: <OrderPrintReceipt /> },
    { path: '/pdf/ttg/assessment/assessmentReport', element: <TTGAssessmentContextLayout><TTGReport/></TTGAssessmentContextLayout> },
    { path: '/pdf/ttg/assessment/progressReport', element: <TTGAssessmentContextLayout><ProgressReport/></TTGAssessmentContextLayout> },
    { path: '/pdf/ttg/surveys', element: <SurveyPdf /> },
    { path: '/pdf/ttg/article', element: <TTGArticlePdf /> }
]);

root.render(
    <StrictMode>
        <HelmetProvider>
            <RouterProvider router={router} />
        </HelmetProvider>
    </StrictMode>
);
